import CoursesApiService from "./api/CoursesApiService";
import { formatPayloadToQueryString } from "@/utils/formatters";

export const getCurricula = async (payload, userToken) => {
    const queryString = formatPayloadToQueryString({
        search: payload.search,
        isActive: payload.isActive,
        courseId: payload.courseId,
        organizationId: payload.organizationId,
        page: payload.page,
        perPage: payload.perPage
    });

    try {
        const response = await CoursesApiService.get(`/curricula${queryString}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar currículos', error);

        throw error;
    }
}

export const getCurriculumById = async (curriculumId, userToken) => {
    try {
        const response = await CoursesApiService.get(`/curricula/${curriculumId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar currículo', error);

        throw error;
    }
}

export const createCurriculum = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/curricula', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao criar currículo', error);

        throw error;
    }
}

export const updateCurriculum = async (payload, userToken) => {
    const { curriculumId, ...curriculum } = payload;

    try {
        const response = await CoursesApiService.put(`/curricula/${curriculumId}`, curriculum, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar currículo', error);

        throw error;
    }
}

export const deleteCurriculum = async (curriculumId, userToken) => {
    try {
        await CoursesApiService.delete(`/curricula/${curriculumId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    } catch (error) {
        console.error('Erro ao deletar currículo', error);

        throw error;
    }
}

export const attachDisciplines = async (curriculumId, disciplineIds, userToken) => {
    try {
        const response = await CoursesApiService.post(`/curricula/${curriculumId}/disciplines/attach-many`, { disciplines: disciplineIds }, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao vincular disciplinas', error);
        throw error;
    }
}

export const detachDiscipline = async (curriculumId, disciplineId, userToken) => {
    try {
        await CoursesApiService.post(`/disciplines/${disciplineId}/curricula/${curriculumId}/detach`, null, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    } catch (error) {
        console.error('Erro ao desvincular disciplina', error);
        throw error;
    }
}

export const changeDisciplineOrder = async (curriculumId, disciplineId, order, userToken) => {
    try {
        const response = await CoursesApiService.post(`/disciplines/${disciplineId}/curricula/${curriculumId}/change-order`, { order }, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
        return response.data;
    } catch (error) {
        console.error('Erro ao alterar ordem da disciplina', error);
        throw error;
    }
}

export default {
    getCurricula,
    getCurriculumById,
    createCurriculum,
    updateCurriculum,
    deleteCurriculum,
    attachDisciplines,
    detachDiscipline,
    changeDisciplineOrder
}